<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer017">
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer018">
<img alt="" class="_idGenObjectAttribute-1" src="image/1-12-14-Comp.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer020">
<img alt="" class="_idGenObjectAttribute-1" src="image/1-12-14-Comp1.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer021">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-1-10-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer022">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> Glory days . . . I never had any, either. I’m still trying to create some, but it’s a lost cause.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer023">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-1-11-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer024">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> Isn’t that a parent’s job, wringing every cent’s worth of value out of everything? I didn’t really think of things that way until I had kids.	</p>
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> The other day I restricted my kid to using just one iPad at a time. Judging by her reaction, it was a pretty unreasonable punishment.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer025">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-1-13-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer026">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> The actual number ended up closer to three and a half zillion.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer027">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-1-14-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer028">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> That last panel makes me cringe.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer029">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-1-15-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer030">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> Little brothers have to use every tool in the annoy-your-sister toolbox.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer031">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-1-16-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer033">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-1-17-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer035">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-1-18-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer036">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> A forward-thinking kid can be a wonderful thing, or diabolical.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer039">
<img alt="" class="_idGenObjectAttribute-1" src="image/1-19-14-Comp1.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer037">
<img alt="" class="_idGenObjectAttribute-1" src="image/1-19-14-Comp.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer038">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> Even though it’s an inordinate amount of work compared to the main part of the strip—or the number of people who will get to see the title panel—I sometimes get obsessed with over-doing something just for my own amusement. This title panel is based on Raphael’s painting, La Madonna di San Sisto. Once I got it back from my coloring assistant, I started work on making it look more like the painting with cracked paint texture and brush strokes.	</p>
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> Newspapers that choose not to run the Sunday title panels are missing out on some great art.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer040">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-3-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer041">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> If you’re gonna ask, ask big.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer042">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-4-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer043">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> Nice thing about having more than one child is the variety. Or extremes.</p>
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> When Rick and I talk to groups, it always surprises me how fast the time goes by. I’m a Zoe.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer044">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-5-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer045">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> Some of my favorite stuff to draw—making faces and sound effects.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer046">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-6-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer048">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-7-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer049">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> Typical marital nicknames have never been our thing. I just feel silly. The only ones we ever used were creative enough to be used as passwords, though. But then we had to stop using them for each other.	</p>
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> Like Darryl and Wanda, my wife and I never got very comfortable with nicknames or endearments. We are on a first-name basis, though.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer050">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-8-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer051">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> Those little routines and rituals really make life complete.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer054">
<img alt="" class="_idGenObjectAttribute-1" src="image/1-26-14-Comp1.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer052">
<img alt="" class="_idGenObjectAttribute-1" src="image/1-26-14-Comp.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer055">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-10-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer056">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> Look it up.	</p>
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> One of my kids did this once. It got bigger laughs than anything I ever wrote.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer057">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-11-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer058">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> Kids think they invented everything.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer059">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-12-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer061">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-13-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer062">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> We have two cars, and I’ve never ridden in the backseat of either one for just this reason.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer063">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-14-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer064">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> Only thing worse than the smell of the van of a family with kids would be what’s collected in the vacuum from the van of a family with kids.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer065">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-15-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer066">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> This happened to us once. We had to sell the van quickly and with the windows rolled down.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer069">
<img alt="" class="_idGenObjectAttribute-1" src="image/2-2-14-Comp1.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer067">
<img alt="" class="_idGenObjectAttribute-1" src="image/2-2-14-Comp.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer068">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> Yeah. There’s a lot of that going around.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer070">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-17-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer071">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> Yet another creepy transformation we’ve put the kids through.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer072">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-18-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer074">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-19-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer075">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> So the secret to ending selfies is shorter arms? Or will we evolve into having longer arms so we don’t need selfie sticks?</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer076">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-20-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer077">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-21-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer078">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> Teaching the baby to say naughty words is an art form. Just ask my little sister, Soapy-Mouth.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer079">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-22-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer082">
<img alt="" class="_idGenObjectAttribute-1" src="image/2-23-14-Comp1.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer080">
<img alt="" class="_idGenObjectAttribute-1" src="image/2-23-14-Comp.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer083">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-24-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer084">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> I think this is actually kind of true. It’s nice when I can share my weirdness with others through the comic strip.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer085">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-25-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer086">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> This one hits a little too close to home for me.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer087">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-26-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer089">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-27-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer091">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-2-28-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer093">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-1-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer095">
<img alt="" class="_idGenObjectAttribute-1" src="image/3-2-14-Compjb.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer096">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> And back to being totally obsessed with a title panel. I was fascinated by how to do her hair to look like the movie poster and re-creating the strip name in the style of Brave. Jerry’s not kidding about his daughter’s hair. It’s amazing.	</p>
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> Our younger daughter is deeply into Disney princesses. The fact that she has hair like Merida from the movie Brave made choosing a Halloween costume really easy that year.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer099">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-3-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer100">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-4-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer101">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> As a freelance illustrator, I used to love to do hand-lettering jobs. This series gave me a chance. I lettered it by hand but wanted to leave it looking a little rough. The “SHAME,” if you could see it in its original black version, is hand-lettered, dry-brush style.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer103">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-5-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer104">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> On Darryl’s shirt—a tiny nod to the Phoenix Suns, who’ve made little cameos in the strip over the years.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer105">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-6-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer107">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-7-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer108">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> That middle panel is just a little bit of heaven for me to do. Love those kinds of drawings.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer109">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-8-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer112">
<img alt="" class="_idGenObjectAttribute-1" src="image/3-9-14-Comp1.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer111">
<img alt="" class="_idGenObjectAttribute-1" src="image/3-9-14-Comp.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer113">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> My mom is terrified of snakes. I think that’s where Wanda’s aversion to them comes from.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer114">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-10-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer116">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-11-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer117">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> It’s possible that I’m the first person to ever publish the sentence, “My shoes are full of peas!”</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer118">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-13-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer119">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-12-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer120">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> Response time is everything in a situation like that.	</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer121">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> I visualize the acting when I write these strips, then fuss with the timing of the dialogue. The third panel in this strip made me laugh when I saw it.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer122">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-14-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer124">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-15-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer125">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> There’s nothing like a habitually naked toddler to keep you on your toes.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer128">
<img alt="" class="_idGenObjectAttribute-1" src="image/3-16-14-Comp1.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer126">
<img alt="" class="_idGenObjectAttribute-1" src="image/3-16-14-Comp.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer127">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> I wanted Wanda’s rant to have a continuous feel, but breaking it up into traditional panels didn’t lend itself to that. This format allowed both the monologue and the action to flow.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer129">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-17-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer131">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-18-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer132">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> Ha! Love that answer.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer133">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-19-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer134">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> Grade school plays are possibly the richest source of kid humor on the planet (especially the really, really bad ones).</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer135">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-20-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer136">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> It’s such a bonding experience to get Mom involved in your games.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer137">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-21-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer138">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> You can learn just about anything off YouTube, provided you don’t get distracted by cat videos, monkey videos, sloth videos, goat videos . . .</p>
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> I have relied on YouTube to learn how to do more things than I care to mention. Or admit to.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer139">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-22-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer143">
<img alt="" class="_idGenObjectAttribute-1" src="image/3-23-14-Comp1.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer141">
<img alt="" class="_idGenObjectAttribute-1" src="image/3-23-14-Comp.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer142">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> If you ever want to meet a bunch of hilariously underdressed people, go to a cartoonists convention.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer144">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-24-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer146">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-25-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer147">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> Understandable.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer148">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-26-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer150">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-27-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer151">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> “Mom” is still my mom’s name. At least nobody told me if she changed it back to Peggy.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer152">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-28-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer154">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-29-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer158">
<img alt="" class="_idGenObjectAttribute-1" src="image/3-30-14-Comp1.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer156">
<img alt="" class="_idGenObjectAttribute-1" src="image/3-30-14-Comp.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer157">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> I will look back on 2014 as “The Year of Title Panel Obsession.” This time: Super Mario Bros.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer159">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-3-31-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer161">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-1-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer163">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-2-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer164">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> Our younger daughter holds the record for Slowest Game Ever at Pismo Bowl. And it was only three frames.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer165">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-3-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer167">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-4-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer168">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> Side note: You’d think after three kids, Wanda would know better than to do that with Wren.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer169">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-5-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer170">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> One of life’s great pleasures is getting away with something by following instructions to the letter.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer173">
<img alt="" class="_idGenObjectAttribute-1" src="image/4-6-14-Comp1.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer171">
<img alt="" class="_idGenObjectAttribute-1" src="image/4-6-14-Comp.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer172">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> If you can’t beat ’em, trick ’em.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer174">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-7-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer175">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> Here was an opportunity to play with the layout. The last panel needed a lot of horizontal space. Luckily, the panel ahead of it also lent itself to being horizontal. Love the word “SPANG!” too.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer176">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-8-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer177">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> Is that a misspelling? Shouldn’t it be “tattletale”? Looks like we all dropped the ball on that one.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer178">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-9-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer179">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> When Hammie is annoying his sisters, you can be pretty sure that I’ve been thinking about my childhood.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer180">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-10-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer182">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-11-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer183">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> Sorry, but Segways are funny.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer184">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-12-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer185">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7"> </span></p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer188">
<img alt="" class="_idGenObjectAttribute-1" src="image/4-13-14-Comp1.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer186">
<img alt="" class="_idGenObjectAttribute-1" src="image/4-13-14-Comp.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer187">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> True story. Not exactly House Beautiful material.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer189">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-14-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer191">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-15-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer192">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> A nurse midwife wrote to tell us that this strip was being displayed at their clinic on their lactation board.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer193">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-16-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer195">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-17-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer196">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> I love this one.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer197">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-18-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer199">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-19-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer200">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> Hmm . . . how to draw the interior of a home-improvement warehouse store, and still be able to read the dialogue and see the characters in a panel the size of a candy bar? Leave out just about everything, and keep a few things as shorthand: A/C unit on a pallet, Rhino Rack shelving, some power and hand tools. Still, the trap box is a little too small. *sigh*	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer203">
<img alt="" class="_idGenObjectAttribute-1" src="image/4-20-14-Comp1.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer201">
<img alt="" class="_idGenObjectAttribute-1" src="image/4-20-14-Comp.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer204">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-21-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer206">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-22-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer207">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> Never lend your good tools to your kids for craft projects. For a while I had a hammer that looked like something you’d find on Elton John’s workbench.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer208">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-23-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer209">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> My kids may not have actually said that, but I’ve seen it in their eyes.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer210">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-24-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer211">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> Now that’s a Universal Truth.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer212">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-25-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer213">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> Universal Truth Number 2.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer214">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-26-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer215">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> Zoe’s optimism about getting a pony is kind of inspiring. You gotta’ believe.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer218">
<img alt="" class="_idGenObjectAttribute-1" src="image/4-27-14-Comp1.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer216">
<img alt="" class="_idGenObjectAttribute-1" src="image/4-27-14-Comp.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer217">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> Wrangling kids and running errands can put some CrossFit workouts to shame.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer219">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-28-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer221">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-29-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer222">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> Oh, if only that could be patented.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer223">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-4-30-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer224">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> Sometimes not showing what’s going on is funnier than showing it.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer225">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-5-1-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer227">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-5-2-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer228">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> Flexibility is the key to a good marriage like Darryl’s and Wanda’s.</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer229">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-5-3-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer230">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> If this were a crime movie, and the characters walked into a room covered in plastic sheeting, that would be foreshadowing. In the MacPhersons’ case it’s S.O.P.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer233">
<img alt="" class="_idGenObjectAttribute-1" src="image/5-4-14-Comp1.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer231">
<img alt="" class="_idGenObjectAttribute-1" src="image/5-4-14-Comp.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer234">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-5-5-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer235">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Rick:</span> Kids are such literalists.	</p>
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer236">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-5-6-14.png"/></div></div>
<div class="_idGenObjectLayout-1"><div id="_idContainer238">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-5-7-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer239">
</div>
<div class="_idGenObjectLayout-1"><div id="_idContainer240">
<img alt="" class="_idGenObjectAttribute-1" src="image/BB-5-8-14.png"/></div></div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer241">
<p class="Body-Copy-JB"><span class="Rick-Jerry CharOverride-7">Jerry:</span> The poor MacPherson kids will probably never get a real pet as long as we have fun making strips like this.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NoYelling_EPUB-11.vue?67a1f7d4